import { getAttendeeMruCache, getMruCache } from '../store/attendeeMruCache';
import { getAttendeeData } from '../selectors/attendeeSelectors';
import { MruCache } from 'owa-mru-cache';
import type FreeBusyRow from '../schema/FreeBusyRow';
import { CACHE_SIZE_IN_PAGES } from '../constants';

export function addAttendeeToMruCache(key: string): void {
    const attendeeData = getAttendeeData(key);
    if (!attendeeData || getAttendeeMruCache(key)) {
        return;
    }

    getMruCache()[key] = new MruCache<FreeBusyRow>('FreeBusyRow', CACHE_SIZE_IN_PAGES);
    getMruCache()[key].initialize(attendeeData.freeBusyData);
}

export function removeAttendeeFromMruCache(key: string): void {
    if (!getAttendeeMruCache(key)) {
        return;
    }

    delete getMruCache()[key];
}
